// SWP planning mock calculations

export const mockCalculateSWP = (formData, calculationMode = 'corpus-to-income') => {
  const { corpusAmount, monthlyIncome, swpPercentage } = formData;
  const swpPercent = parseFloat(swpPercentage);

  if (calculationMode === 'corpus-to-income') {
    // Standard calculation: Corpus → Income
    const corpus = parseFloat(corpusAmount);
    
    // Calculate yearly SWP = Corpus Amount × SWP Percentage
    const yearlySwp = Math.round(corpus * (swpPercent / 100));
    
    // Calculate monthly SWP = Yearly SWP ÷ 12
    const monthlySwp = Math.round(yearlySwp / 12);

    return {
      corpusAmount: Math.round(corpus),
      swpPercentage: swpPercent,
      yearlySwp: yearlySwp,
      monthlySwp: monthlySwp
    };
  } else {
    // Reverse calculation: Income → Corpus
    const monthlyReq = parseFloat(monthlyIncome);
    
    // Calculate yearly income requirement = Monthly × 12
    const yearlySwp = Math.round(monthlyReq * 12);
    
    // Calculate required corpus = Yearly Income ÷ (SWP% / 100)
    const corpusRequired = Math.round(yearlySwp / (swpPercent / 100));

    return {
      monthlyIncome: Math.round(monthlyReq),
      swpPercentage: swpPercent,
      yearlySwp: yearlySwp,
      corpusRequired: corpusRequired
    };
  }
};